// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutUs_entry-img__g5xKw{
    position: absolute;
    z-index: -1;
    margin-top: -15vw;
    width: 100vw;
    height: 60vw;
}

.AboutUs_explore-heading__sP2rU{
    font-size: 5vw;
    text-align: center;
    font-family: dm-sans-medium;
    letter-spacing: -2px;
    margin-bottom: 0;
}

.AboutUs_explore-desc__HEMhb{
    font-size: 1.5vw;
    width: 85vw;
    margin-left: 7.5vw;
    text-align: center;
    font-weight: 300;
}

.AboutUs_join-club__SMvV6{
    font-size: 4vw;
    font-family: dm-sans-regular;
    font-weight: 500;
    text-align: center;
    margin-top: 8vw;
}

.AboutUs_grid-perks__nEzJQ{
    display: grid;
    justify-content: center;
    text-align: center;
    place-content: center;
    margin-top: 5vw;
    grid-template-columns: 30vw 30vw 30vw;
    row-gap: 6vw;
    margin-bottom: 5vw;
}

.AboutUs_our-team-text__vazDX{
    font-size: 4vw;
    text-align: center;
}

.AboutUs_our-team-container__7JH0p{
    width: 85vw;
    height: auto;
    margin-bottom: 6vw;
    margin-left: 7.5vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.AboutUs_our-team-container-2__ArBAu{
    width: 85vw;
    height: auto;
    margin-bottom: 6vw;
    margin-left: 7.5vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.AboutUs_member-container__LtYff{
    width: 40vw;
}

.AboutUs_member-name__6U56L{
    font-size: 3.3vw;
    text-align: center;
    margin-bottom: 0vw;
    margin-top: 0vw;
}

.AboutUs_member-info__1uCiU{
    text-align: justify;
    font-size: 1.2vw;
    line-height: 2vw;
    margin-bottom: 0;
}

.AboutUs_member-photo__aNIbJ{
    width: 35vw;
    height: 30vw;
    align-self: center;
    object-fit: cover;
    border-radius: 0.7vw;
}

@media(max-width: 768px){
    .AboutUs_entry-img__g5xKw{
        position: absolute;
        z-index: -1;
        margin-top: -7rem;
        width: 100vw;
        height: 60vw;
    }
    
    .AboutUs_explore-heading__sP2rU{
        font-size: 8.5vw;
        text-align: center;
        font-family: dm-sans-medium;
        letter-spacing: 0px;
        margin-bottom: 0;
    }
    
    .AboutUs_explore-desc__HEMhb{
        font-size: 4vw;
        width: 85vw;
        margin-left: 7.5vw;
        text-align: justify;
        font-weight: 300;
    }
    
    .AboutUs_join-club__SMvV6{
        text-align: center;
        /* font-size: 44px; */
        font-size: 6vw;
        margin-bottom: 8vw;
        margin-top: 10vw;
    }
    
    .AboutUs_grid-perks__nEzJQ{
        display: grid;
        justify-content: center;
        text-align: center;
        place-content: center;
        margin-top: -3vw;
        grid-template-columns: 30vw 30vw 30vw;
        row-gap: 6vw;
        margin-bottom: 5vw;
    }
    
    .AboutUs_our-team-text__vazDX{
        font-size: 6vw;
        margin-top: 10vw;
        text-align: center;
    }
    
    .AboutUs_our-team-container__7JH0p{
        width: 85vw;
        height: auto;
        margin-bottom: 6vw;
        margin-left: 7.5vw;
        display: flex;
        flex-direction: column-reverse;
        justify-content: space-between;
    }

    .AboutUs_our-team-container-2__ArBAu{
        width: 85vw;
        height: auto;
        margin-bottom: 6vw;
        margin-left: 7.5vw;
        margin-top: 15vw;
        display: flex;
        flex-direction: column-reverse;
        justify-content: space-between;
    }
    
    .AboutUs_member-container__LtYff{
        width: 80vw;
        align-self: center;
    }
    
    .AboutUs_member-name__6U56L{
        font-size: 6vw;
        text-align: center;
        margin-bottom: 1vw;
        margin-top: 5vw;
    }
    
    .AboutUs_member-info__1uCiU{
        text-align: justify;
        font-size: 4vw;
        line-height: 7vw;
        margin-bottom: 0;
    }
    
    .AboutUs_member-photo__aNIbJ{
        width: 70vw;
        height: 60vw;
        align-self: center;
        object-fit: cover;
        border-radius: 0.7vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/FooterPages/AboutUs/AboutUs.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,qCAAqC;IACrC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,iBAAiB;QACjB,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,2BAA2B;QAC3B,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;QACrB,cAAc;QACd,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,kBAAkB;QAClB,qBAAqB;QACrB,gBAAgB;QAChB,qCAAqC;QACrC,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,aAAa;QACb,8BAA8B;QAC9B,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;QACjB,oBAAoB;IACxB;AACJ","sourcesContent":[".entry-img{\n    position: absolute;\n    z-index: -1;\n    margin-top: -15vw;\n    width: 100vw;\n    height: 60vw;\n}\n\n.explore-heading{\n    font-size: 5vw;\n    text-align: center;\n    font-family: dm-sans-medium;\n    letter-spacing: -2px;\n    margin-bottom: 0;\n}\n\n.explore-desc{\n    font-size: 1.5vw;\n    width: 85vw;\n    margin-left: 7.5vw;\n    text-align: center;\n    font-weight: 300;\n}\n\n.join-club{\n    font-size: 4vw;\n    font-family: dm-sans-regular;\n    font-weight: 500;\n    text-align: center;\n    margin-top: 8vw;\n}\n\n.grid-perks{\n    display: grid;\n    justify-content: center;\n    text-align: center;\n    place-content: center;\n    margin-top: 5vw;\n    grid-template-columns: 30vw 30vw 30vw;\n    row-gap: 6vw;\n    margin-bottom: 5vw;\n}\n\n.our-team-text{\n    font-size: 4vw;\n    text-align: center;\n}\n\n.our-team-container{\n    width: 85vw;\n    height: auto;\n    margin-bottom: 6vw;\n    margin-left: 7.5vw;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.our-team-container-2{\n    width: 85vw;\n    height: auto;\n    margin-bottom: 6vw;\n    margin-left: 7.5vw;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.member-container{\n    width: 40vw;\n}\n\n.member-name{\n    font-size: 3.3vw;\n    text-align: center;\n    margin-bottom: 0vw;\n    margin-top: 0vw;\n}\n\n.member-info{\n    text-align: justify;\n    font-size: 1.2vw;\n    line-height: 2vw;\n    margin-bottom: 0;\n}\n\n.member-photo{\n    width: 35vw;\n    height: 30vw;\n    align-self: center;\n    object-fit: cover;\n    border-radius: 0.7vw;\n}\n\n@media(max-width: 768px){\n    .entry-img{\n        position: absolute;\n        z-index: -1;\n        margin-top: -7rem;\n        width: 100vw;\n        height: 60vw;\n    }\n    \n    .explore-heading{\n        font-size: 8.5vw;\n        text-align: center;\n        font-family: dm-sans-medium;\n        letter-spacing: 0px;\n        margin-bottom: 0;\n    }\n    \n    .explore-desc{\n        font-size: 4vw;\n        width: 85vw;\n        margin-left: 7.5vw;\n        text-align: justify;\n        font-weight: 300;\n    }\n    \n    .join-club{\n        text-align: center;\n        /* font-size: 44px; */\n        font-size: 6vw;\n        margin-bottom: 8vw;\n        margin-top: 10vw;\n    }\n    \n    .grid-perks{\n        display: grid;\n        justify-content: center;\n        text-align: center;\n        place-content: center;\n        margin-top: -3vw;\n        grid-template-columns: 30vw 30vw 30vw;\n        row-gap: 6vw;\n        margin-bottom: 5vw;\n    }\n    \n    .our-team-text{\n        font-size: 6vw;\n        margin-top: 10vw;\n        text-align: center;\n    }\n    \n    .our-team-container{\n        width: 85vw;\n        height: auto;\n        margin-bottom: 6vw;\n        margin-left: 7.5vw;\n        display: flex;\n        flex-direction: column-reverse;\n        justify-content: space-between;\n    }\n\n    .our-team-container-2{\n        width: 85vw;\n        height: auto;\n        margin-bottom: 6vw;\n        margin-left: 7.5vw;\n        margin-top: 15vw;\n        display: flex;\n        flex-direction: column-reverse;\n        justify-content: space-between;\n    }\n    \n    .member-container{\n        width: 80vw;\n        align-self: center;\n    }\n    \n    .member-name{\n        font-size: 6vw;\n        text-align: center;\n        margin-bottom: 1vw;\n        margin-top: 5vw;\n    }\n    \n    .member-info{\n        text-align: justify;\n        font-size: 4vw;\n        line-height: 7vw;\n        margin-bottom: 0;\n    }\n    \n    .member-photo{\n        width: 70vw;\n        height: 60vw;\n        align-self: center;\n        object-fit: cover;\n        border-radius: 0.7vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry-img": `AboutUs_entry-img__g5xKw`,
	"explore-heading": `AboutUs_explore-heading__sP2rU`,
	"explore-desc": `AboutUs_explore-desc__HEMhb`,
	"join-club": `AboutUs_join-club__SMvV6`,
	"grid-perks": `AboutUs_grid-perks__nEzJQ`,
	"our-team-text": `AboutUs_our-team-text__vazDX`,
	"our-team-container": `AboutUs_our-team-container__7JH0p`,
	"our-team-container-2": `AboutUs_our-team-container-2__ArBAu`,
	"member-container": `AboutUs_member-container__LtYff`,
	"member-name": `AboutUs_member-name__6U56L`,
	"member-info": `AboutUs_member-info__1uCiU`,
	"member-photo": `AboutUs_member-photo__aNIbJ`
};
export default ___CSS_LOADER_EXPORT___;
